export const API = {
    ServiceAPI: null,
    use: function(api) {
      API.ServiceAPI = api
    }
}

class APIService {
    constructor() {

    }

    get(uri,options) {
      return API.ServiceAPI.get(uri, options)
    }

    async clear(path) {
      if(!API.ServiceAPI || !API.ServiceAPI.cache) return
      if(!path) return await API.ServiceAPI.cache.clear()
      return await API.ServiceAPI.cache.removeItem(`${API.ServiceAPI.defaults.baseURL}${path}`)
    }

    post(uri, payload, options) {
      return API.ServiceAPI.post(uri, payload, options)
    }

    put(uri, payload, options) {
      return API.ServiceAPI.put(uri, payload, options)
    }

    delete(uri, options) {
      return API.ServiceAPI.delete(uri, options)
    }
}

export default APIService
